import { api } from "../../app/api";
import { setCredentials, setUserOnly } from "./authSlice";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({
        url: "/admins/login",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // expect { token, user }
          dispatch(setCredentials(data));
        } catch {}
      },
    }),
    me: build.query({
      query: () => "/admins/me",
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUserOnly(data)); // expect user object
        } catch {}
      },
    }),
  }),
});

export const { useLoginMutation, useMeQuery } = authApi;
